import { gql, TypedDocumentNode } from '@apollo/client';
import type { ConsumableLineItem } from '../models/ConsumableLineItem';

export const UPDATE_CONSUMABLE_LINE_ITEMS_MUTATION: TypedDocumentNode<{ updated: boolean }, { consumableLineItemModels: ConsumableLineItem[] }> = gql`
  mutation UpdateConsumableLineItems($consumableLineItemModels: [ConsumableLineItemModelInput!]!) {
    updated: updateConsumableLineItems(consumableLineItemModels: $consumableLineItemModels)
  }
`;